import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from "react";
import { FaPlus } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  selectCategories,
} from "../../redux/features/category/CategorySlice";
import {
  getConsumerItem,
  RESET_ITEM,
  selectConsumerItems,
  selectitems,
  selectUpdateItemSuccess,
  updateItem,
} from "../../redux/features/item/ItemSlice";
import { useNavigate, useParams } from "react-router-dom";
import { FiX } from "react-icons/fi";
import {
  getIngredients,
  selectIngredients,
} from "../../redux/features/ingredient/IngredientSlice";
import { toast } from "react-toastify";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert";
import {
  getAllUOMs,
  selectUnitOfMeasures,
} from "../../redux/features/unitOfMeasure/UnitOfMeasureSlice";

const EditItemForm = forwardRef((props, ref) => {
  const { setEdit } = props;
  const [formData, setFormData] = useState({
    itemName: "",
    description: "",
    category: "",
    price: 0,
    itemType: "producation",
    inventory: 0,
    conversionRate: 0,
    inventoryUnit: "",
    purchaseUnit: "",
  });

  const { id } = useParams();
  const items = useSelector(selectitems);
  const categories = useSelector(selectCategories);
  const ingredients = useSelector(selectIngredients);
  const consumerItems = useSelector(selectConsumerItems);
  const unitOfMeasures = useSelector(selectUnitOfMeasures);

  const item = items.find((item) => item._id === id);
  //   console.log(item);

  const [errors, setErrors] = useState({});

  useLayoutEffect(() => {
    if (item) {
      setFormData({
        itemName: item?.name,
        description: item?.description,
        category: item?.category,
        price: item?.price,
        inventory: 0,
        itemType: item?.itemType,
        conversionRate: item?.conversionRate,
        inventoryUnit: item?.inventoryUnit,
        purchaseUnit: item?.purchaseUnit,
      });
      setFields(item?.ingredients);
      setFieldItems(item?.dealItems);
    }
  }, [item]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setEdit?.(true);
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.itemName) newErrors.itemName = "Item name is required.";
    if (!formData.category) newErrors.category = "Item category is required.";
    if (!formData.price) {
      newErrors.price = "Price is required.";
    }
    if (formData.itemType === "consumer") {
      if (!formData.inventoryUnit)
        newErrors.inventoryUnit = "Inventory Unit is required.";
      if (!formData.purchaseUnit)
        newErrors.purchaseUnit = "Purchase Unit is required.";
      if (!formData.conversionRate)
        newErrors.conversionRate = "ConversionRate is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectUpdateItemSuccess);
  const navigate = useNavigate();
  // deal category and quantity
  const [fields, setFields] = useState([]);
  const [error, setError] = useState([]);

  const handleAddField = () => {
    setFields([
      ...fields,
      {
        ingredientQuantity: 1,
        ingredientName: "",
        ingredientId: "",
        unitOfMeasure: "",
      },
    ]);
    setEdit?.(true);
    setError([...error, {}]);
  };

  const confirmRemoveIngredient = (index, name) => {
    if (name && name.trim() !== "") {
      confirmAlert({
        title: "Remove Ingredient",
        message: `Are you sure you want to remove the ingredient "${name}"? Any unsaved changes will be lost.`,
        buttons: [
          {
            label: "Yes",
            onClick: () => handleRemoveField(index),
          },
          {
            label: "No",
          },
        ],
      });
    } else {
      handleRemoveField(index);
    }
    setEdit?.(true);
  };

  const handleRemoveField = (index) => {
    if (fields.length > 0) {
      setFields(fields.filter((_, i) => i !== index));
      setError(error.filter((_, i) => i !== index));
    }
    setEdit?.(true);
  };

  const handleChange = (index, name, value) => {
    setFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index
          ? name === "ingredient"
            ? {
                ...field,
                ingredientId:
                  ingredients.find((ing) => ing._id === value)?._id ||
                  field.ingredientId,
                ingredientName:
                  ingredients.find((ing) => ing._id === value)?.name ||
                  field.ingredientName,
                unitOfMeasure:
                  ingredients.find((ing) => ing._id === value)?.inventoryUnit ||
                  field?.unitOfMeasure,
              }
            : { ...field, [name]: Number(value) }
          : field
      )
    );
    setEdit?.(true);
    // Clear errors when a field is updated
    setError((prevErrors) =>
      prevErrors.map((err, i) => (i === index ? { ...err, [name]: "" } : err))
    );
  };

  // deal item
  const [fieldItems, setFieldItems] = useState([]);
  const [errorItem, setErrorItem] = useState([]);

  const handleAddFieldItem = () => {
    setFieldItems([
      ...fieldItems,
      { itemQuantity: 1, itemName: "", itemId: "", unitOfMeasure: "" },
    ]);
    setEdit?.(true);
    setErrorItem([...errorItem, {}]);
  };

  const confirmRemoveItem = (index, name) => {
    if (name && name.trim() !== "") {
      confirmAlert({
        title: "Remove Item",
        message: `Are you sure you want to remove the item "${name}"? Any unsaved changes will be lost.`,
        buttons: [
          {
            label: "Yes",
            onClick: () => handleRemoveFieldItem(index),
          },
          {
            label: "No",
          },
        ],
      });
    } else {
      handleRemoveFieldItem(index);
    }
    setEdit?.(true);
  };

  const handleRemoveFieldItem = (index) => {
    if (fieldItems.length > 0) {
      setFieldItems(fieldItems.filter((_, i) => i !== index));
      setErrorItem(errorItem.filter((_, i) => i !== index));
    }
    setEdit?.(true);
  };

  const handleChangeItem = (index, name, value) => {
    setFieldItems((prevFieldItems) =>
      prevFieldItems.map((item, i) =>
        i === index
          ? name === "item"
            ? {
                ...item,
                itemId:
                  consumerItems.find((ci) => ci._id === value)?._id ||
                  item.itemId,
                itemName:
                  consumerItems.find((ci) => ci._id === value)?.name ||
                  item.itemName,
                unitOfMeasure:
                  consumerItems.find((ci) => ci._id === value)?.inventoryUnit ||
                  item.unitOfMeasure,
              }
            : { ...item, [name]: Number(value) }
          : item
      )
    );
    setEdit?.(true);
    // Clear errors when a field is updated
    setErrorItem((prevErrorItems) =>
      prevErrorItems.map((err, i) =>
        i === index ? { ...err, [name]: "" } : err
      )
    );
  };
  const validateFields = () => {
    if (fields.length === 0) {
      setFields([]);
      return true;
    }
    const seenIngredients = new Map();
    const newErrors = fields.map((field, index) => {
      const fieldErrors = {};

      if (!field.ingredientName) {
        fieldErrors.ingredientName = "Ingredient is required.";
      } else {
        if (seenIngredients.has(field.ingredientId)) {
          fieldErrors.ingredientName =
            "Ingredient already exists. Please update the quantity.";
        } else {
          seenIngredients.set(field.ingredientId, index);
        }
      }

      if (
        !field.ingredientQuantity ||
        isNaN(field.ingredientQuantity) ||
        field.ingredientQuantity <= 0
      ) {
        fieldErrors.ingredientQuantity = "Quantity must be a positive number.";
      }

      if (!field.unitOfMeasure)
        fieldErrors.unitOfMeasure = "Unit of measure is requried";

      return fieldErrors;
    });

    setError(newErrors);

    return newErrors.every((error) => Object.keys(error).length === 0);
  };

  const validateFieldItems = () => {
    if (fieldItems.length === 0) {
      setFieldItems([]);
      return true;
    }
    const seenItems = new Map();
    const newErrors = fieldItems.map((fieldItem, index) => {
      const fieldErrors = {};

      if (!fieldItem.itemName) {
        fieldErrors.itemName = "Item is required.";
      } else {
        if (seenItems.has(fieldItem.itemId)) {
          fieldErrors.itemName =
            "Item already exists. Please update the quantity.";
        } else {
          seenItems.set(fieldItem.itemId, index);
        }
      }

      if (
        !fieldItem.itemQuantity ||
        isNaN(fieldItem.itemQuantity) ||
        fieldItem.itemQuantity <= 0
      ) {
        fieldErrors.itemQuantity = "Quantity must be a positive number.";
      }
      if (!fieldItem.unitOfMeasure)
        fieldErrors.unitOfMeasure = "Unit of measure is requried";

      return fieldErrors;
    });

    setErrorItem(newErrors);

    return newErrors.every((error) => Object.keys(error).length === 0);
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill the requried field correct");
      return;
    }

    const fieldItemsValid = validateFieldItems();
    const fieldsValid = validateFields();

    if (!fieldItemsValid || !fieldsValid) {
      console.error("Validation failed. Please check the errors.");
      return;
    }

    const updateItemData = {
      name: formData.itemName,
      description: formData.description,
      category: formData.category,
      price: formData.price,
      inventory: formData.itemType === "producation" ? 0 : formData.inventory,
      itemType: formData.itemType,
      ingredients: formData.itemType === "producation" ? fields : [],
      dealItems: formData.itemType === "producation" ? fieldItems : [],
      conversionRate:
        formData.itemType === "producation" ? 0 : formData.conversionRate,
      purchaseUnit:
        formData.itemType === "producation" ? "" : formData.purchaseUnit,
      inventoryUnit:
        formData.itemType === "producation" ? "" : formData.inventoryUnit,
    };

    await dispatch(updateItem({ id: item._id, updateItemData }));
  };

  useEffect(() => {
    if (isSuccess) {
      navigate("/items");
      dispatch(RESET_ITEM());
    }
  }, [isSuccess, navigate]);

  useImperativeHandle(ref, () => ({
    submitForm: handleSubmit,
  }));

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getIngredients());
    dispatch(getConsumerItem());
    dispatch(getAllUOMs());
  }, [dispatch]);

  const itemOptions = consumerItems?.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const ingredientOptions = ingredients?.map((ingredient) => ({
    value: ingredient._id,
    label: ingredient.name,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      borderBottom: "1px solid #0D868C",
      borderRadius: "0px",
      boxShadow: "none",
      outline: "none",
      backgroundColor: "transparent",
      minHeight: "30px",
      padding: "none",
      textTransform: "capitalize",
      cursor: "pointer",
      "&:hover": {
        borderBottom: "1px solid #0D868C",
        boxShadow: "none",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 130,
      overflowY: "auto",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#A9A9A9",
      fontSize: "0.9rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#A9A9A9",
      fontSize: "0.9rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0D868C"
        : state.isFocused
        ? "#E0F7FA"
        : "white",
      color: state.isSelected ? "white" : "#0D868C",
      padding: "4px",
      fontSize: "0.9rem",
      textTransform: "capitalize",
    }),
  };

  return (
    <div className="flex items-center w-full justify-center bg-[#F1F1F1] min-h-screen inner-container">
      <div className="bg-white py-8 md:px-16 px-8 my-16 rounded-lg shadow-md md:w-[75%] w-[85%]">
        <form
        // onSubmit={handleSubmit}
        >
          {/* Item type */}
          <div className="mb-4 flex flex-col items-start">
            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
              Item Type
            </label>
            <select
              name="itemType"
              value={formData.itemType}
              onChange={handleInputChange}
              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
            >
              <option value="consumer" className="capitalize">
                Consumer
              </option>
              <option value="producation" className="capitalize">
                Production
              </option>
            </select>
            {errors.itemType && (
              <span className="text-red-500 text-sm">{errors.itemType}</span>
            )}
          </div>

          {/* Item Name */}
          <div className="mb-4 flex flex-col items-start">
            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
              Item Name
            </label>
            <input
              type="text"
              name="itemName"
              value={formData.itemName}
              onChange={handleInputChange}
              placeholder="Name"
              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
            />
            {errors.itemName && (
              <span className="text-red-500 text-sm">{errors.itemName}</span>
            )}
          </div>

          {/* Description */}
          <div className="mb-4 flex flex-col items-start">
            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
              Description
            </label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Description"
              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
            />
          </div>

          {/* Category */}
          <div className="mb-4 flex flex-col items-start">
            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
              Category
            </label>
            <select
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
            >
              <option value="">No category</option>
              {categories?.map((category, index) => (
                <option
                  key={index}
                  value={category.name.toLowerCase()}
                  className="capitalize"
                >
                  {category.name}
                </option>
              ))}
            </select>
            {errors.category && (
              <span className="text-red-500 text-sm">{errors.category}</span>
            )}
          </div>

          {/* Price */}
          <div className="mb-4 flex flex-col items-start">
            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
              Price
            </label>
            <input
              type="number"
              name="price"
              min={0}
              step={0.1}
              onWheel={(e) => e.target.blur()}
              value={formData.price}
              onChange={handleInputChange}
              placeholder="Price"
              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
            />
            {errors.price && (
              <span className="text-red-500 text-sm">{errors.price}</span>
            )}
          </div>

          {/* Ingredient and Quantity */}
          {formData.itemType === "producation" ? (
            <>
              <div className="mb-4 flex flex-col items-start mt-2 gap-3">
                <p className="text-[#0D868C] font-semibold my-4">
                  Add Ingredients that are included in Recipe and their Quantity
                </p>

                {fields.map((field, index) => (
                  <div key={index} className="w-full mb-4">
                    <div key={index} className="w-full flex items-end gap-2 ">
                      {/* Select Dropdown */}
                      <div className=" flex flex-col items-start w-[40%]">
                        <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                          Ingredient
                        </label>

                        <Select
                          options={ingredientOptions}
                          value={
                            ingredientOptions.find(
                              (opt) => opt.value === field.ingredientId
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            handleChange(
                              index,
                              "ingredient",
                              selectedOption?.value
                            )
                          }
                          placeholder="Search Item"
                          styles={customStyles}
                          isSearchable
                          className="w-full text-[.9rem] font-normal text-[#A9A9A9] outline-none"
                        />
                      </div>
                      {/* Number Input */}

                      <div className="flex-1  ">
                        <div className="flex items-end justify-between gap-2">
                          <div className="flex-grow  flex flex-col items-start ">
                            <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                              Quantity
                            </label>
                            <input
                              type="number"
                              name="ingredientQuantity"
                              min={0.01}
                              onWheel={(e) => e.target.blur()}
                              value={field.ingredientQuantity}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  "ingredientQuantity",
                                  e.target.value
                                )
                              }
                              placeholder="Enter the quantity"
                              className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                            />
                          </div>

                          <div className="flex-grow  flex flex-col items-start">
                            <span
                              className="text-[.75rem] font-semibold text-[#7D7D7D]"
                              title="unit Of Measure"
                            >
                              UOM
                            </span>
                            <input
                              type="text"
                              value={field.unitOfMeasure}
                              readOnly
                              placeholder="Unit Of Measure"
                              className="w-full outline-none rounded-none text-[1rem] bg-[#f5f4f4] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                            />
                          </div>

                          {/* Remove Button */}
                          {fields.length > 0 && (
                            <button
                              type="button"
                              onClick={() =>
                                confirmRemoveIngredient(
                                  index,
                                  fields[index]?.ingredientName
                                )
                              }
                              className="bg-red-500 text-white rounded-md  flex-none"
                            >
                              <FiX className="lg:size-8 size-6" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full flex-col gap-1">
                      {error[index]?.ingredientName && (
                        <span className=" text-red-500 text-sm">
                          {error[index].ingredientName}
                        </span>
                      )}

                      {error[index]?.ingredientQuantity && (
                        <span className=" text-red-500 text-sm">
                          {error[index].ingredientQuantity}
                        </span>
                      )}
                      {error[index]?.unitOfMeasure && (
                        <span className=" text-red-500 text-sm">
                          {error[index].unitOfMeasure}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddField}
                  className="uppercase border-2 flex items-center justify-center border-[#0D868C] text-[#0D868C] px-4 py-2 rounded-full cursor-pointer "
                >
                  <FaPlus className="size-5 mr-3" />
                  Add Ingredient
                </button>

                {formData?.category?.includes("deal") &&
                  fieldItems.map((fieldItem, index) => (
                    <div key={index} className="w-full mb-4">
                      <div key={index} className="w-full flex items-end gap-2 ">
                        {/* Select Dropdown */}
                        <div className=" flex flex-col items-start w-[40%]">
                          <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                            Item
                          </label>

                          <Select
                            options={itemOptions}
                            value={
                              itemOptions.find(
                                (opt) => opt.value === fieldItem.itemId
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChangeItem(
                                index,
                                "item",
                                selectedOption?.value
                              )
                            }
                            placeholder="Search Item"
                            styles={customStyles}
                            isSearchable
                            className="w-full text-[.9rem] font-normal text-[#A9A9A9] outline-none"
                          />
                        </div>
                        {/* Number Input */}

                        <div className="flex-1  ">
                          <div className="flex items-end justify-between gap-2">
                            <div className="flex-grow  flex flex-col items-start ">
                              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                                Quantity
                              </label>
                              <input
                                type="number"
                                name="itemQuantity"
                                min={1}
                                onWheel={(e) => e.target.blur()}
                                value={fieldItem.itemQuantity}
                                onChange={(e) =>
                                  handleChangeItem(
                                    index,
                                    "itemQuantity",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter the quantity"
                                className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                              />
                            </div>
                            <div className="flex-grow  flex flex-col items-start">
                              <span
                                className="text-[.75rem] font-semibold text-[#7D7D7D]"
                                title="unit Of Measure"
                              >
                                UOM
                              </span>
                              <input
                                type="text"
                                value={fieldItem.unitOfMeasure}
                                readOnly
                                placeholder="Unit Of Measure"
                                className="w-full outline-none rounded-none text-[1rem] bg-[#f5f4f4] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                              />
                            </div>

                            {/* Remove Button */}
                            {fieldItems.length > 0 && (
                              <button
                                type="button"
                                onClick={() =>
                                  confirmRemoveItem(
                                    index,
                                    fieldItems[index]?.itemName
                                  )
                                }
                                className="bg-red-500 text-white rounded-md  flex-none"
                              >
                                <FiX className="lg:size-8 size-6" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex w-full flex-col gap-[2px]">
                        {errorItem[index]?.itemName && (
                          <span className="flex-1 text-red-500 text-sm">
                            {errorItem[index].itemName}
                          </span>
                        )}

                        {errorItem[index]?.itemQuantity && (
                          <span className=" text-red-500 text-sm">
                            {errorItem[index].itemQuantity}
                          </span>
                        )}
                        {errorItem[index]?.unitOfMeasure && (
                          <span className=" text-red-500 text-sm">
                            {errorItem[index].unitOfMeasure}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                {formData?.category?.includes("deal") && (
                  <button
                    type="button"
                    onClick={handleAddFieldItem}
                    className="uppercase border-2 flex items-center justify-center border-[#0D868C] text-[#0D868C] px-4 py-2 rounded-full cursor-pointer "
                  >
                    <FaPlus className="size-5 mr-3" />
                    Add Item
                  </button>
                )}
              </div>
            </>
          ) : (
            // {/* Inventory */}
            <>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Inventory
                </label>
                <input
                  type="number"
                  name="inventory"
                  min={1}
                  step={1}
                  onWheel={(e) => e.target.blur()}
                  value={formData.inventory}
                  onChange={handleInputChange}
                  placeholder="Inventory"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>

              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Inventory Unit
                </label>
                {/* <input
                  type="text"
                  name="inventoryUnit"
                  value={formData.inventoryUnit}
                  onChange={handleInputChange}
                  placeholder="Inventory Unit gram,pcs etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                /> */}
                <select
                  name="inventoryUnit"
                  value={formData.inventoryUnit}
                  onChange={handleInputChange}
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="">Select Inventory Unit</option>
                  {unitOfMeasures?.map((unitOfMeasure, index) => (
                    <option
                      key={index}
                      value={unitOfMeasure.name.toLowerCase()}
                      className="capitalize"
                    >
                      {unitOfMeasure.name}
                    </option>
                  ))}
                </select>
                {errors.inventoryUnit && (
                  <span className="text-red-500 text-sm">
                    {errors.inventoryUnit}
                  </span>
                )}
              </div>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Purchase Unit
                </label>
                {/* <input
                  type="text"
                  name="purchaseUnit"
                  value={formData.purchaseUnit}
                  onChange={handleInputChange}
                  placeholder="Purchase Unit kg,pack etc"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                /> */}

                <select
                  name="purchaseUnit"
                  value={formData.purchaseUnit}
                  onChange={handleInputChange}
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="">Select Purchase Unit</option>
                  {unitOfMeasures?.map((unitOfMeasure, index) => (
                    <option
                      key={index}
                      value={unitOfMeasure.name.toLowerCase()}
                      className="capitalize"
                    >
                      {unitOfMeasure.name}
                    </option>
                  ))}
                </select>
                {errors.purchaseUnit && (
                  <span className="text-red-500 text-sm">
                    {errors.purchaseUnit}
                  </span>
                )}
              </div>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Conversion Rate
                </label>
                <input
                  type="number"
                  name="conversionRate"
                  min={1}
                  step={1}
                  onWheel={(e) => e.target.blur()}
                  value={formData.conversionRate}
                  onChange={handleInputChange}
                  placeholder="Conversion Rate 1000,30 etc"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.conversionRate && (
                  <span className="text-red-500 text-sm">
                    {errors.conversionRate}
                  </span>
                )}
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
});

export default EditItemForm;
